import * as actionTypes from '../types'
import {updateObject} from '../../utils/utility'

const initialState = {
    payload: null,
    errors: null,
    isLoading: false,
    isSucceedForAdd: null,
    isSucceedForGetAll: null,
    isSucceedForGet: null,
    isSucceedForPut: null,
    isSucceedForDelete: null,
    isSucceed: null,
    isSucceedForGetByCode: null,
    isSucceedUpdate: null,
    isSucceedForLockoutUsers: null,
    isSucceedForResetPassword: null,
    isSucceedForGenerateToken: null,
    payloadForResetToken: null, 
    isSucceedForDelete: null,   
};
const getAllStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getAllSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetAll: action.isSucceedForGetAll,
    });
};
const getAllFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getAllReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetAll: action.isSucceedForGetAll,
    });
};
const acceptUserStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const acceptUserSuccess = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceed: action.isSucceed,
    });
};
const acceptUserFail = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceed: action.isSucceed,
    });
};
const acceptUserReset = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceed: action.isSucceed,
    });
};

const getUserByCodeStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getUserByCodeSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetByCode: action.isSucceedForGetByCode,
    });
};
const getUserByCodeFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getUserByCodeReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGetByCode: action.isSucceedForGetByCode,
    });
};
const updateUserStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const updateUserSuccess = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedUpdate: action.isSucceedUpdate,
    });
};
const updateUserFail = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedUpdate: action.isSucceedUpdate,
    });
};
const updateUserReset = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedUpdate: action.isSucceedUpdate,
    });
};
const getLockoutUsersStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const getLockoutUsersSuccess = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForLockoutUsers: action.isSucceedForLockoutUsers,
    });
};
const getLockoutUsersFail = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
    });
};
const getLockoutUsersReset = (state, action) => {
    return updateObject(state, {
        payload: action.payload,
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForLockoutUsers: action.isSucceedForLockoutUsers,
    });
};
const denyUserStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const denyUserSuccess = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceed: action.isSucceed,
    });
};
const denyUserFail = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceed: action.isSucceed,
    });
};
const denyUserReset = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceed: action.isSucceed,
    });
};
const generateUserPasswordResetTokenStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const generateUserPasswordResetTokenSuccess = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGenerateToken: action.isSucceedForGenerateToken,
        payloadForResetToken: action.payloadForResetToken,
    });
};
const generateUserPasswordResetTokenFail = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGenerateToken: action.isSucceedForGenerateToken,
    });
};
const generateUserPasswordResetTokenReset = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForGenerateToken: action.isSucceedForGenerateToken,
        payloadForResetToken: action.payloadForResetToken,
    });
};
const resetUserPassswordStart = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForResetPassword: action.isSucceedForResetPassword,
    });
};
const resetUserPassswordSuccess = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForResetPassword: action.isSucceedForResetPassword,
    });
};
const resetUserPassswordFail = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForResetPassword: action.isSucceedForResetPassword,
    });
};
const resetUserPassswordReset = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForResetPassword: action.isSucceedForResetPassword,
    });
};
const deleteUserStart = (state, action) => {
    return updateObject(state, {
        isLoading: action.isLoading,
    });
};
const deleteUserSuccess = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForDelete: action.isSucceed,
    });
};
const deleteUserFail = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForDelete: action.isSucceed,
    });
};
const deleteUserReset = (state, action) => {
    return updateObject(state, {
        errors: action.errors,
        isLoading: action.isLoading,
        isSucceedForDelete: action.isSucceed,
    });
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ALL_USER_START:
            return getAllStart(state, action);
        case actionTypes.GET_ALL_USER_SUCCESS:
            return getAllSuccess(state, action);
        case actionTypes.GET_ALL_USER_FAIL:
            return getAllFail(state, action);
        case actionTypes.GET_ALL_USER_RESET:
            return getAllReset(state, action);
        case actionTypes.ACCEPT_USER_START:
            return acceptUserStart(state, action);
        case actionTypes.ACCEPT_USER_SUCCESS:
            return acceptUserSuccess(state, action);
        case actionTypes.ACCEPT_USER_FAIL:
            return acceptUserFail(state, action);
        case actionTypes.ACCEPT_USER_RESET:
            return acceptUserReset(state, action);
        case actionTypes.DENY_USER_START:
            return denyUserStart(state, action);
        case actionTypes.DENY_USER_SUCCESS:
            return denyUserSuccess(state, action);
        case actionTypes.DENY_USER_FAIL:
            return denyUserFail(state, action);
        case actionTypes.DENY_USER_RESET:
            return denyUserReset(state, action);
        case actionTypes.GET_USER_BY_CODE_START: 
            return getUserByCodeStart(state, action);
        case actionTypes.GET_USER_BY_CODE_SUCCESS: 
            return getUserByCodeSuccess(state, action);
        case actionTypes.GET_USER_BY_CODE_FAIL:
            return getUserByCodeFail(state, action);
        case actionTypes.GET_USER_BY_CODE_RESET:
            return getUserByCodeReset(state, action);
        case actionTypes.UPDATE_USER_START:
            return updateUserStart(state, action);
        case actionTypes.UPDATE_USER_SUCCESS:
            return updateUserSuccess(state, action);
        case actionTypes.UPDATE_USER_FAIL:
            return updateUserFail(state, action);
        case actionTypes.UPDATE_USER_RESET:
            return updateUserReset(state, action);
        case actionTypes.GET_LOCKOUT_USERS_START:
            return getLockoutUsersStart(state, action);
        case actionTypes.GET_LOCKOUT_USERS_SUCCESS:
            return getLockoutUsersSuccess(state, action);
        case actionTypes.GET_LOCKOUT_USERS_FAIL:
            return getLockoutUsersFail(state, action);
        case actionTypes.GET_LOCKOUT_USERS_RESET:
            return getLockoutUsersReset(state, action);
        case actionTypes.GENERATE_USER_RESET_PASSWORD_TOKEN_START:
            return generateUserPasswordResetTokenStart(state, action);
        case actionTypes.GENERATE_USER_RESET_PASSWORD_TOKEN_SUCCESS:
            return generateUserPasswordResetTokenSuccess(state, action);
        case actionTypes.GENERATE_USER_RESET_PASSWORD_TOKEN_FAIL:
            return generateUserPasswordResetTokenFail(state, action);
        case actionTypes.GENERATE_USER_RESET_PASSWORD_TOKEN_RESET:
            return generateUserPasswordResetTokenReset(state, action);
        case actionTypes.RESET_USER_PASSWORD_START:
            return resetUserPassswordStart(state, action);
        case actionTypes.RESET_USER_PASSWORD_SUCCESS:
            return resetUserPassswordSuccess(state, action);
        case actionTypes.RESET_USER_PASSWORD_FAIL:
            return resetUserPassswordFail(state, action);
        case actionTypes.RESET_USER_PASSWORD_RESET:
            return resetUserPassswordReset(state, action);
        case actionTypes.DELETE_USER_START:
            return deleteUserStart(state, action);
        case actionTypes.DELETE_USER_SUCCESS:
            return deleteUserSuccess(state, action);
        case actionTypes.DELETE_USER_FAIL:
            return deleteUserFail(state, action);
        case actionTypes.DELETE_USER_RESET:
            return deleteUserReset(state, action);
        default:
            return state;
    };
};

export default reducer;